module.exports = __webpack_public_path__ + "static/media/18ECA10.48f87a41.jpg";